/**
 * PersonelEkleModal.jsx — TEK "Personel Ekle" akışı (backlog #115), SAKA ve firma tarafı için.
 *
 * Eskiden dört ayrı yol vardı: Personel Listesi'nde formla açılan "Yeni Personel Ekle" (sorgusuz,
 * var olan TCKN'de patlıyordu) ve "Detaylı Kayıt" (Kişi Listesi'ndeki bu modale yönlendirme),
 * Daimî Liste'nin ve firma portalı Personel Listem'in yalnızca-sorgu "Kişi Ekle"leri (yeni kişide
 * çıkmaz sokak). Hepsi bu bileşene indi.
 *
 * Tek akış, sekmesiz:
 *   1. T.C./Pasaport no sorgulanır (GET /personnel/kimlik-sorgu, tam eşleşme).
 *   2. Kayıt yoksa kişi bilgileri istenir; varsa bulunan kişi özetlenir; yasaklıysa durulur.
 *   3. Kişi firmanın personel listesine eklenir; "fuara görevlendir" açıksa ayrıca fuara atanır
 *      (o zaman firma fuara EŞLİ olmalı — stand ya da dekoratör taşeronu, kisiFirmaEsleService).
 *      `fuarId` verilmezse anahtar ve altındaki her şey (fuar bağı kontrolü, meslek) hiç çizilmez, yalnızca listeye eklenir:
 *      firma portalı böyle açar (#589 — anahtar orada çalışmıyordu, #513); fuara atama satırdaki "Fuara Görevlendir"le,
 *      meslek kişi sayfasından yapılır. SAKA tarafı `fuarId` verir, anahtarı korur.
 *
 * İki kullanım biçimi (`firma` prop'u):
 *   · KİLİTLİ firma (`firma` verilir) — Firma Detay › Personel Listesi, Daimî Liste, firma portalı.
 *     Firma seçici yok; liste eklemesi HER ZAMAN yapılır, anahtar (varsa) yalnızca fuar atamasını yönetir.
 *   · SERBEST (`firma` yok) — Kişi Listesi. Firma seçilir; anahtar kapalıysa firma isteğe bağlıdır
 *     (yalnızca kart açılır). Birden fazla firma eklenebilir (backlog #132): her satırın kendi firması,
 *     fuar bağı kontrolü, "Fuara eşle"si ve mesleği var ve bir (kişi, firma, fuar) satırı yazar —
 *     person_firma_to_fuar'da kişi başına tekil anahtar yok, `/yeni` firma başına satır ekler (taşımaz).
 *
 * İki arayan (`isFirmaAccount()`), kimlik-sorgu yanıtı da buna göre değişir (backend karar verir):
 *   · SAKA   → `MEVCUT_KAYIT` (asla EKLENEBILIR değil) + telefon, geçmiş görevler, mükerrer kart
 *             uyarısı. Ölçüt `personId` + `!yasakli`; "Kimliği Doğrula", "Yeni Firma", "Fuara Eşle"
 *             yalnızca SAKA'da.
 *   · Firma  → #112'den beri her yasaksız kişi için `EKLENEBILIR` + `personId` + ad/soyad (telefon yok;
 *             başka hangi firmada çalıştığı söylenmez). Yasaklıda personId bile gelmez.
 *   Her iki yanıtta da dallanma `personId` + `yasakli` üzerinden yürüyor, katalogdaki `action` üzerinden
 *   DEĞİL — SAKA'da action OPEN_CARD olduğu için ona bakan bir "Ekle" butonu hiç görünmezdi.
 *
 * Kayıt zinciri (hepsi ayrı çağrı, geri alınamaz):
 *   yeni kişi  POST /yenikart (bir kez) → her firma için sırayla: POST /firma/{id}/personel → [POST /yeni]
 *   var olan   her firma için sırayla: POST /firma/{id}/personel (idempotent) → [POST /yeni]
 * `/yeni` ancak kişi firmanın AKTİF listesindeyse çalışır (409 aksi halde), o yüzden liste adımı hep
 * önce gelir. Fuar `/yeni` gövdesinde `fuar_id` olarak gider (#387).
 * WAS (until #387): "Fuar gövdede değil `X-fuar-id` başlığında gider." — backend başlığı okumuyordu, işe alım GİRİŞ
 * anındaki fuara yazılıyordu.
 *
 * ⚠️ Yarım kalan zincir: `/yenikart` firmaya hiçbir şey bağlamaz ve firma kullanıcısı listeye girmemiş
 * bir kartı OKUYAMAZ/DÜZENLEYEMEZ. Kart oluştuktan sonra bir firmanın liste/atama adımı düşerse (vergi no
 * kapısı, ağ, 409) diğer firmalar etkilenmez; sonuç ekranı HER FİRMANIN sonucunu ayrı gösterir ve
 * "Başarısızları tekrar dene" yalnızca düşenleri koşar — kart çoğaltılmaz, başarılı satırlar tekrarlanmaz
 * (oluşan kişi id'si ve satır sonuçları tutulur; liste adımı geçmiş bir satır yalnızca atamayı dener).
 * Vergi no kapısı (`denyIfNoTaxNumber`) yalnızca firma arayanı bağlar ve `/yenikart`ta YOK, yani en kolay
 * yetim kart yolu o: firma arayan için oluşturmadan ÖNCE kontrol edilir.
 *
 * ⚠️ "Zaten listede" için firma yanıtında sinyal yok (`dahaOnceCalisti` fuar görevlendirmesidir, liste
 * üyeliği değil). Liste ekleme idempotent olduğundan sonucu ekleme çağrısının mesajından öğreniyoruz.
 *
 * Kimlik doğrulama (backend #54): giriş kartı için HER fuarda zorunlu (Özel İzin hâlâ muaf tutar).
 * Ekleme bunun için ENGELLENMEZ, kapı karttadır; ama sorgudan sonra ve sonuç ekranında kişinin durumu
 * rozetle gösterilir, SAKA için doğrulanmamışsa sonuç ekranı KimlikDogrulamaModal'ı açmayı önerir.
 * TCKN/uyruk uyarısı da yalnızca uyarıdır (bkz. kimlikNo.js).
 *
 * BİLİNEN KİŞİ (`bilinenKisi` prop'u, #261 "Fuara Eşle"): kişi zaten elimizde (Kişi Listesi satırı, Kart Yazdır
 * penceresi) — kimlik sorgusu atlanır, `sorgu` doğrudan MEVCUT_KAYIT şekline kurulur; kayıt zinciri, sonuç
 * ekranı ve "Kimliği Doğrula" aynı kalır. Hedef fuar HER ZAMAN `fuarId` (üst çubuk), "fuara görevlendir" anahtarı
 * yoktur (düğmenin işi zaten o). Açılışta GET /personnel/{personId}/firmalar (#265, yalnızca SAKA) okunur:
 *   · ilk satır, kişinin EN SON çalıştığı ve bu fuarda henüz olmayan firmasıyla (yoksa boş) önden doldurulur,
 *   · bir satırın firması kişiyi bu fuarda ZATEN taşıyorsa satır işaretlenir ve kayıt kapanır (aynı çağrı yalnızca
 *     meslek güncellerdi; reddedilmiş eşleme de bu yoldan açılmaz).
 * Aynı bilinen-kişi durumuna #288'in "Evet, bu kişi"si de düşer (o zaman prop yok, anahtar ve satırlar kullanıcıda kalır).
 * Kilitli bilinen kişide (#402) pencerenin başında Kart Yazdır / Kimlik Doğrula'daki ortak künye şeridi durur (KisiKunyeSeridi:
 * vesikalık, ad, T.C., telefon, kimlik durumu, fuar logosu; durum 1 değilse şeritteki düğme Kimlik Doğrula'yı üstüne açar) ve
 * "Kimlik doğrulama: ... kart alamaz" uyarısı HİÇ çıkmaz (sonuç ekranında da); uyarı yalnızca kimlik sorgusu akışında kalır.
 * `firmayaEsle` (Kişi Listesi'nin Fuara Eşlenmiş görünümü): kişi zaten fuarda, işin adı "Firmaya Eşle"dir; `baskaFirmayaEsle`
 * ile (satır bu fuarda başka bir firmayla eşli) "Başka Firmaya Eşle".
 * Aynı /firmalar verisinden künye şeridinin altında "Firmaları" listesi çıkar (#477, KisiFirmalariOzeti): her firmanın bu
 * fuardaki durumu + kişi zaten eşliyse üstte bilgi notu. Yalnızca bilgi — kaydı engellemez.
 *
 * BENZER KİŞİ (#288, backend #287): yeni kart `POST /yenikart`ta 409 BENZER_KAYIT dönerse kişi OLUŞTURULMAZ,
 * adaylar ayrı bir pencerede sorulur: "Evet, bu kişi" → o kişiyle bilinen-kişi akışı; "Hayır, farklı kişi" →
 * aynı form `benzerKayitOnaylandi=true` ile yeniden gider.
 */
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Badge, Spinner, Alert, Input, Label, Row, Col,
  InputGroup, FormGroup,
} from "reactstrap";
import {
  Search, CheckCircle2, XCircle, Link2, Info, ShieldCheck, ShieldX, ShieldQuestion, AlertTriangle, Plus, X,
} from "lucide-react";
import FirmaSearchSelect from "../Firma/FirmaSearchSelect";
import CreateFirmaModal from "../Firma/CreateFirmaModal";
import FirmaFuarEsleModal from "./FirmaFuarEsleModal";
import KimlikDogrulamaModal from "./KimlikDogrulamaModal";
import KisiKunyeSeridi from "./KisiKunyeSeridi";
import MeslekSecici from "./MeslekSecici";
import { EslesmeDurumRozeti } from "./PersonelDurumParcalari";
import { firmaAdi } from "./PersonelFirmaBelgeParcalari";
import { assignPersonToFirmaAdmin, createPersonAdmin, getKisiFirmalari } from "../../services/personnelAdminService";
import { kimlikSorgu, addToRoster, KIMLIK_SORGU_SONUC, ESLESME_DURUM } from "../../services/personelRosterService";
import { getMeslekList } from "../../services/kisiAdminService";
import { getFirmaFuarBaglari } from "../../services/kisiFirmaEsleService";
// WAS (until #435): import { getTaxNumber } from "../../services/cardAccessService";
import { getVergiNoDurumu } from "../../services/cardAccessService";
import { isFirmaAccount } from "../../services/firmaSessionService";
import { getKisiTelefonsuzEklemeAcik } from "../../services/systemSettingsService";
import { BAGLAM } from "../../services/egitimBaglam";
import { kimlikUyarisi, varsayilanUyruk } from "./kimlikNo";
import TelefonGirdisi from "../Common/TelefonGirdisi";
import { STATUS_HEX, NEUTRAL_GRAY } from "../Projects/StandPills";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

const EMPTY = { name: "", surname: "", nationalityId: "1", phone: "", email: "" };

// person_kimlik_dogrulama_durum → rozet. Renkler StandPills'in sabit hex paletinden
// (bu temada `success`/`secondary` sınıfları ters görünüyor, bkz. KimlikDogrulamaModal).
const KIMLIK_ROZET = {
  0: { get label() { return i18n.t("components:personelEkle.dogrulanmadi"); }, hex: NEUTRAL_GRAY, Icon: ShieldQuestion },
  1: { get label() { return i18n.t("components:personelEkle.dogrulandi"); }, hex: STATUS_HEX.success, Icon: ShieldCheck },
  2: { get label() { return i18n.t("components:personelEkle.reddedildi"); }, hex: STATUS_HEX.danger, Icon: ShieldX },
  3: { get label() { return i18n.t("components:personelEkle.alandaDogrulanacak"); }, hex: STATUS_HEX.info, Icon: ShieldQuestion }, // #664
};

export const KIMLIK_KART_NOTU =
  "Giriş kartı için kimlik doğrulaması her fuarda zorunludur. Doğrulanmamış kişiler, SGK işe " +
  "giriş bildirgesi ile doğrulanana kadar (veya Özel İzin verilene kadar) kart alamaz.";

/**
 * Kişi ekleme akışının ortak "kimlik doğrulama" satırı: durum rozeti + kart notu.
 * `durum`/`durumAdi` kimlik-sorgu yanıtından (kimlikDogrulamaDurum/-DurumAdi) gelir;
 * `yeniKayit` → kart henüz yok, "Doğrulanmadı" olarak açılacak.
 * ⚠️ Yalnızca bilgi — eklemeyi engellemez, kapı giriş kartındadır.
 */
export function KimlikDogrulamaBilgisi({ durum, durumAdi = null, yeniKayit = false, className = "" }) {
  const { t } = useTranslation("components");
  const d = yeniKayit ? 0 : Number(durum ?? 0);
  const meta = KIMLIK_ROZET[d] ?? { ...KIMLIK_ROZET[0], label: durumAdi || KIMLIK_ROZET[0].label };
  const { Icon } = meta;
  return (
    <div className={`small ${className}`}>
      <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
        <span className="text-muted">{t("personelEkle.kimlikDogrulama")}</span>
        <span
          className="badge fw-normal d-inline-flex align-items-center gap-1"
          style={{ backgroundColor: meta.hex }} title={durumAdi || undefined}
        >
          <Icon size={12} />{meta.label}
        </span>
        {yeniKayit && <span className="text-muted">{t("personelEkle.yeniKisiKartiDogrulanmamisOlarak")}</span>}
      </div>
      <Alert fade={false} color="info" className="py-2 px-2 mb-0 d-flex align-items-start gap-2">
        <Info size={14} className="flex-shrink-0 mt-1" />
        <span>{/* WAS (until #334): {KIMLIK_KART_NOTU} */}{t("personelEkle.kimlikKartNotu")}</span>
      </Alert>
    </div>
  );
}

function bagOzeti(bag) {
  const parcalar = [
    ...bag.standlar.map((s) => `Stand ${s.standName}${s.salonName ? ` (${s.salonName})` : ""}`),
    ...bag.dekoratorler.map((d) => i18n.t("components:personelEkle.taseronu", { v: d.anaFirmaAdi || `Firma #${d.anaFirmaId}` })),
  ];
  return parcalar.slice(0, 2).join(" · ") + (parcalar.length > 2 ? ` +${parcalar.length - 2}` : "");
}

/** Kişi Listesi satırı (GET /personnel/kisi-listesi kaydı) → "Fuara Eşle"nin bildiği kişi. */
export function kisiSatirindanBilinenKisi(r) {
  return {
    personId: Number(r.personId), ad: r.name, soyad: r.surname, telefon: r.phone || null,
    kimlikNo: r.tcNo || r.tcNoMasked || null,
    kimlikDurum: r.kimlikDogrulama?.durum ?? 0, kimlikDurumAdi: r.kimlikDogrulama?.durumAdi ?? null,
    yasakli: Boolean(r.forbidden), fotografVar: Boolean(r.fotografVar),
  };
}

/** Benzer-kişi uyarısındaki aday (`adaylar[]`, #288) → bilinen kişi. Firma girişinde yasaklı adayın `personId`si yoktur. */
function adaydanBilinenKisi(a) {
  return {
    personId: a.personId != null ? Number(a.personId) : null, ad: a.ad, soyad: a.soyad,
    kimlikNo: a.kimlikNo || a.kimlikNoMasked || null,
    kimlikDurum: a.kimlikDogrulamaDurum ?? 0, kimlikDurumAdi: a.kimlikDogrulamaDurumAdi ?? null,
    yasakli: Boolean(a.yasakli), dahaOnceCalisti: Boolean(a.dahaOnceCalisti),
    sonGorev: a.sonFirmaAdi ? { fuarAdi: a.sonFuarAdi, firmaAdi: a.sonFirmaAdi } : null,
  };
}

/** Bilinen kişiyi `kimlik-sorgu`nun MEVCUT_KAYIT yanıtı şekline çevirir: kayıt zinciri ve sonuç ekranı değişmez. */
function bilinenSorgu(k) {
  return {
    yapilabilecek: "MEVCUT_KAYIT", sonuc: KIMLIK_SORGU_SONUC.MEVCUT_KAYIT,
    personId: k.personId, ad: k.ad, soyad: k.soyad, telefon: k.telefon || null,
    yasakli: k.yasakli, kimlikDogrulamaDurum: k.kimlikDurum, kimlikDogrulamaDurumAdi: k.kimlikDurumAdi,
    dahaOnceCalisti: k.dahaOnceCalisti,
    gecmisGorevler: k.sonGorev ? [{ fuar_adi: k.sonGorev.fuarAdi, firma_name: k.sonGorev.firmaAdi }] : undefined,
  };
}

/**
 * Ön dolum firması: kişinin EN SON çalıştığı firma (güncel olanlar önde, sonra son fuar tarihi) — bu fuarda
 * zaten olanlar ve adı olmayan (silinmiş) firmalar hariç. Yoksa null: ilk satır boş açılır.
 */
function onDolumFirmasi(veri, fuarId) {
  const adaylar = (veri?.firmalar || []).filter(
    (f) => f.firmaName && f.gorevSayisi > 0 && !(f.gorevler || []).some((g) => Number(g.fuarId) === Number(fuarId)),
  );
  adaylar.sort((a, b) => (Number(b.guncel) - Number(a.guncel))
    || String(b.sonFuarTarihi || "").localeCompare(String(a.sonFuarTarihi || "")));
  const f = adaylar[0];
  return f ? { firmaId: f.firmaId, firmaName: f.firmaName, firmaShortname: f.firmaShortname } : null;
}

const BENZER_FARK = {
  get HANE_DEGISIK() { return i18n.t("components:personelEkle.birHaneFarkli"); },
  get YER_DEGISMIS() { return i18n.t("components:personelEkle.ikiHaneYerDegistirmis"); },
  get EKSIK_HANE() { return i18n.t("components:personelEkle.yazdiginizNumaradaBirHaneEksik"); },
  get FAZLA_HANE() { return i18n.t("components:personelEkle.yazdiginizNumaradaBirHaneFazla"); },
};

/**
 * "Bu kişiyi tekrar yaratıyor olabilir misiniz?" (#288). `adaylar[]` backend'den gelir; yasaklı bir adayın
 * firma girişinde `personId`si yoktur ve yasaklı kişi hiçbir yerde seçilemez.
 */
function BenzerKisiModal({ benzer, kimlikNo, busy, onEvet, onHayir, onVazgec }) {
  const { t } = useTranslation("components");
  return (
    <Modal isOpen centered toggle={busy ? undefined : onVazgec}>
      <ModalHeader toggle={busy ? undefined : onVazgec}>{t("personelEkle.buKisiyiTekrarYaratiyorOlabilir")}</ModalHeader>
      <ModalBody>
        <div className="small mb-3">
          {t("personelEkle.ayniAdSoyadlaKimlikNumarasi")}{" "}<strong>{kimlikNo}</strong>{" "}{t("personelEkle.ileTekHaneFarkli")}{" "}{benzer.adaylar.length > 1 ? t("personelEkle.kayitlar") : t("personelEkle.birKayit")}{" "}{t("personelEkle.var")}
        </div>
        {benzer.adaylar.map((a) => {
          const secilemez = !a.personId || a.yasakli;
          return (
            <div key={a.personId ?? a.kimlikNoMasked} className="p-2 rounded border mb-2 d-flex justify-content-between align-items-start gap-3">
              <div className="small">
                <div className="fw-semibold">
                  {a.ad} {a.soyad}
                  {a.yasakli && <Badge color="danger" className="ms-2 fw-normal">{t("personelEkle.girisiYasakli")}</Badge>}
                </div>
                <div className="text-muted">
                  {a.kimlikNo || a.kimlikNoMasked}{BENZER_FARK[a.fark] ? ` — ${BENZER_FARK[a.fark]}` : ""}
                </div>
                <div className="text-muted">{t("personelEkle.kimlik")}{" "}{a.kimlikDogrulamaDurumAdi || t("personelEkle.dogrulanmadi")}</div>
                {a.sonFirmaAdi && (
                  <div className="text-muted">{t("personelEkle.sonGorev")}{" "}{[a.sonFirmaAdi, a.sonFuarAdi].filter(Boolean).join(" · ")}</div>
                )}
                {a.dahaOnceCalisti && <div className="text-success">{t("personelEkle.dahaOnceFirmanizdaCalismis")}</div>}
              </div>
              <Button color="primary" size="sm" className="text-nowrap" disabled={busy || secilemez} onClick={() => onEvet(a)}>
                {t("personelEkle.evetBuKisi")}
              </Button>
            </div>
          );
        })}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onVazgec} disabled={busy}>{t("personelEkle.vazgec")}</Button>
        <Button color="warning" onClick={onHayir} disabled={busy}>
          {busy ? <Spinner size="sm" /> : t("personelEkle.hayirFarkliKisi")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

/** Bir satırın firmasıyla kişinin bu fuardaki durumu (GET /personnel/{id}/firmalar): zaten var / ilişki sonlandırılmış. */
function FirmaIliskiNotu({ kayit, gorev }) {
  const { t } = useTranslation("components");
  if (gorev) {
    return (
      <div className="small mt-1 text-danger">
        <Info size={13} className="me-1" />
        {t("personelEkle.buFuardaZatenVar")}{" "}{gorev.eslesmeDurumuAdi || t("personelEkle.gorevlendirilmis")}{gorev.meslekAdi ? ` · ${gorev.meslekAdi}` : ""}
      </div>
    );
  }
  if (kayit?.iliskiDurumu === "SONLANDIRILDI") {
    return (
      <div className="small mt-1 text-muted">
        <Info size={13} className="me-1" />
        {t("personelEkle.buFirmaylaIliskiSonlandirilmis")}{kayit.bitisTarihi ? ` (${String(kayit.bitisTarihi).slice(0, 10)})` : ""}
      </div>
    );
  }
  return null;
}

/** Firma listesinde bu kadar satırdan sonrası "Tümünü göster"in arkasında (Kişi Detay › Firmalar › Çalışan ile aynı). */
const FIRMA_ILK_SATIR = 5;

/**
 * Bilinen kişinin firmaları, üst çubuk fuarındaki durumuyla (#477): "bu fuarda zaten eşli mi" sorusunun cevabı, aynı işlem
 * tekrar yapılmasın diye. Veri `GET /personnel/{id}/firmalar` (`firmalar[].gorevler[]`, fuar başına bir kayıt); yeni uç yok.
 * YALNIZCA BİLGİ: kaydı engellemez, bir kişi aynı fuarda iki firmayla da çalışabilir (#479'un sayımı: fuar 294'te 843 kişiden 9'u).
 * Reddedilmiş görevlendirme "eşli" sayılmaz (backend #476: satır düğmesi de o kişide yeşil kalır) ama satırında Reddedildi yazar.
 * Sıra: bu fuardakiler, sonra güncel olanlar, sonra sonlandırılanlar. Çalışan ilişkisi (`YOK`: yalnızca işveren satırı) ve
 * görevi olmayan firmalar listelenmez.
 */
function KisiFirmalariOzeti({ firmalar, fuarId }) {
  const { t } = useTranslation("components");
  const [hepsi, setHepsi] = useState(false);
  const satirlar = (firmalar || [])
    .filter((f) => f.gorevSayisi > 0 || (f.iliskiDurumu && f.iliskiDurumu !== "YOK"))
    .map((f) => ({ f, gorev: (f.gorevler || []).find((g) => Number(g.fuarId) === Number(fuarId)) ?? null }))
    .sort((a, b) => (Number(Boolean(b.gorev)) - Number(Boolean(a.gorev)))
      || (Number(Boolean(b.f.guncel)) - Number(Boolean(a.f.guncel)))
      || String(b.f.sonFuarTarihi || "").localeCompare(String(a.f.sonFuarTarihi || "")));
  if (satirlar.length === 0) return null;

  const durumAdi = (g) => g.eslesmeDurumuAdi || (g.eslesmeDurumu != null ? ESLESME_DURUM[g.eslesmeDurumu]?.label : null);
  const meslekOf = (g) => (g.meslekler || []).map((m) => m.meslekAdi).filter(Boolean).join(", ") || g.meslekAdi || null;
  const esliOlanlar = satirlar.filter(({ gorev }) => gorev && gorev.eslesmeDurumu !== 2);
  const gorunen = hepsi ? satirlar : satirlar.slice(0, FIRMA_ILK_SATIR);

  return (
    <div className="mt-3">
      {esliOlanlar.length > 0 && (
        <Alert fade={false} color="info" className="py-2 px-2 mb-2 small d-flex align-items-start gap-2">
          <Info size={14} className="flex-shrink-0 mt-1" />
          <span>
            {t("personelEkle.buFuardaZatenEsli", {
              firmalar: esliOlanlar.map(({ f, gorev }) => (durumAdi(gorev) ? `${firmaAdi(f)} (${durumAdi(gorev)})` : firmaAdi(f))).join(", "),
            })}
          </span>
        </Alert>
      )}
      <div className="small text-muted mb-1">{t("personelEkle.firmalari")}</div>
      {gorunen.map(({ f, gorev }, i) => {
        const durum = gorev ? durumAdi(gorev) : null;
        const meslek = gorev ? meslekOf(gorev) : null;
        return (
          <div key={f.firmaId} className={`d-flex align-items-center gap-2 flex-wrap py-1 ${i > 0 ? "border-top" : ""}`}>
            <span className="fw-medium text-break" title={f.firmaName || undefined}>{firmaAdi(f)}</span>
            {f.iliskiDurumu === "SONLANDIRILDI" && (
              <Badge color="light" className="text-muted border fw-normal">{t("personelKart.iliskiSonlandirildi")}</Badge>
            )}
            {gorev ? (
              <>
                {durum && gorev.eslesmeDurumu != null ? (
                  <EslesmeDurumRozeti durum={gorev.eslesmeDurumu}>{t("personelEkle.buFuardaDurum", { durum })}</EslesmeDurumRozeti>
                ) : (
                  <span className="small" style={{ color: STATUS_HEX.success }}><CheckCircle2 size={13} className="me-1" />{t("personelEkle.buFuarda")}</span>
                )}
                {meslek && <span className="small text-muted">· {meslek}</span>}
              </>
            ) : (
              <span className="small text-muted">{t("personelEkle.buFuardaDegil")}</span>
            )}
          </div>
        );
      })}
      {satirlar.length > FIRMA_ILK_SATIR && (
        <Button color="link" size="sm" className="p-0 mt-1 text-decoration-none" onClick={() => setHepsi((v) => !v)}>
          {hepsi ? t("personelEkle.dahaAzGoster") : t("personelEkle.tumunuGoster", { v: satirlar.length - FIRMA_ILK_SATIR })}
        </Button>
      )}
    </div>
  );
}

let satirSayaci = 0;
/** Bir firma satırı = bir (firma, meslekler) görevlendirmesi; #372'den beri bir görevlendirme BİRDEN ÇOK meslek taşır. */
const yeniSatir = (firma = null, meslekIds = []) => ({ key: ++satirSayaci, firma, meslekIds });
const MAKS_FIRMA = 10;

/** Bir firmanın fuar bağı durumu: kontrol sürüyor / hata / eşli (özet) / eşli değil (+ "Fuara eşle"). Kişi Detay › Firmalar da kullanır (#365). */
export function BagDurumu({ bag, firmaArayan, onEsle }) {
  const { t } = useTranslation("components");
  return (
    <div className="small mt-1">
      {!bag ? (
        <span className="text-muted"><Spinner size="sm" className="me-1" />{t("personelEkle.fuarBagiKontrolEdiliyor")}</span>
      ) : bag.error ? (
        <span className="text-danger">{bag.error}</span>
      ) : bag.data?.esli ? (
        <span style={{ color: STATUS_HEX.success }}><CheckCircle2 size={13} className="me-1" />{bagOzeti(bag.data)}</span>
      ) : (
        <span className="d-flex align-items-center gap-2">
          <span className="text-danger">{t("personelEkle.firmaBuFuaraEsliDegil")}</span>
          {!firmaArayan && (
            <Button color="link" size="sm" className="p-0" onClick={onEsle}>
              <Link2 size={13} className="me-1" />{t("personelEkle.fuaraEsle")}
            </Button>
          )}
        </span>
      )}
    </div>
  );
}

/**
 * @param {number|null} fuarId      görevlendirme fuarı (`/yeni`'nin `fuar_id`si, #387) + meslek listesi; yoksa fuar adımları gizlenir
 * @param {string}      fuarLabel   anahtarın yanında/sonuçta gösterilen ad
 * @param {string|null} fuarLogoUrl bilinen kişinin künye şeridinin sağındaki fuar logosu (yoksa fuar adı yazılır)
 * @param {boolean}     firmayaEsle bilinen kişide başlık ve düğme "Fuara Eşle" yerine "Firmaya Eşle" olur (#401)
 * @param {boolean}     baskaFirmayaEsle `firmayaEsle` ile birlikte: kişi bu fuarda başka bir firmayla zaten eşli, "Başka Firmaya Eşle" (#401)
 * @param {object|null} firma       KİLİTLİ firma {firmaId, firmaName?}; verilmezse serbest mod (firma satırları)
 * @param {object|null} initialFirma serbest modda ilk satırın başlangıç firması (bilinen kişide: firmalar okunamazsa yedek)
 * @param {boolean}     assignDefault "fuara görevlendir" anahtarının başlangıç değeri
 * @param {object|null} bilinenKisi  #261 — kişi zaten elde (`kisiSatirindanBilinenKisi`); kimlik sorgusu atlanır
 * @param {Function}    onDone      her kayıt turu bitince ({ personId, assigned, already }) — kısmi başarıda da
 */
export default function PersonelEkleModal({
  fuarId = null, fuarLabel = null, fuarLogoUrl = null, firmayaEsle = false, baskaFirmayaEsle = false,
  firma: kilitliFirma = null, initialFirma = null,
  assignDefault = true, bilinenKisi: bilinenKisiProp = null, onClose, onDone,
  // #511: a Yabancı Katılımcı has no Permanent / Temporary distinction, so the staff-type picker is not drawn (nothing is sent).
  calisanTipiGizli = false,
}) {
  const { t: tx } = useTranslation("components");
  const firmaArayan = isFirmaAccount();
  const fuarEtiketi = fuarLabel || (fuarId ? tx("personelEkle.fuar", { fuarId }) : "");
  // Listeden "Fuara Eşle" ile açıldıysa kişi sabittir (kimlik kutusu yok, "başka kişi ara" yok, "bir kişi daha" yok).
  const bilinenKilitli = Boolean(bilinenKisiProp);
  const eslemeAdi = firmayaEsle
    ? tx(baskaFirmayaEsle ? "personelEkle.baskaFirmayaEsle" : "personelEkle.firmayaEsle")
    : tx("personelEkle.fuaraEsle2");

  const [kimlikNo, setKimlikNo] = useState("");
  const [bilinen, setBilinen] = useState(bilinenKisiProp);
  const [sorgu, setSorgu] = useState(() => (bilinenKisiProp ? bilinenSorgu(bilinenKisiProp) : null));
  const [sorguLoading, setSorguLoading] = useState(false);

  const [form, setForm] = useState(EMPTY);
  const [fuaraGorevlendir, setFuaraGorevlendir] = useState(Boolean(fuarId) && (assignDefault || bilinenKilitli));
  // #357 (backend #356): listeye eklenirken elle çalışan tipi — "" Belirsiz, "1" Daimî, "2" Geçici. Yalnızca YENİ satıra yazılır.
  const [calisanTipiSecimi, setCalisanTipiSecimi] = useState("");
  // Kilitli modda tek satır (firması `kilitliFirma`), serbest modda kullanıcı satır ekler/siler.
  // Bilinen kişide (SAKA) ilk satırı firma listesi gelince doldururuz; o zamana kadar boş açılır.
  const [satirlar, setSatirlar] = useState(() => [yeniSatir(bilinenKilitli && !firmaArayan ? null : initialFirma)]);
  // Satır anahtarı → { durum: "ok" | "hata", rosterTamam, already, hata }. Yeniden denemede yalnızca "ok" olmayanlar koşar.
  const [satirSonuc, setSatirSonuc] = useState({});
  const [mesleks, setMesleks] = useState([]);

  // Firmaların fuar bağı, `${firmaId}|${fuarId}|${yenileme}` anahtarıyla. Güncel anahtarla eşleşmeyen kayıt "kontrol sürüyor" sayılır.
  const [baglar, setBaglar] = useState({});
  const [bagToken, setBagToken] = useState(0);
  const istenenBaglar = useRef(new Set());
  const [firmaOlusturSatir, setFirmaOlusturSatir] = useState(null); // "Yeni Firma"nın doldurulacağı satırın anahtarı
  const [firmaOlusturAd, setFirmaOlusturAd] = useState(""); // aramada eşleşmeyen metin → yeni firmanın adı (#281)
  const [esleHedef, setEsleHedef] = useState(null); // { firma, yeniFirma }
  // Bu popup'ta açılan firmalar: eşleme iptal edilip sonra tekrar açılırsa firma_to_fuar yine yazılsın.
  const [yeniFirmaIdleri, setYeniFirmaIdleri] = useState([]);

  // Firma arayan için vergi no kapısı: { key, durum: "var" | "yok" | "bilinmiyor" }.
  const [vergi, setVergi] = useState({ key: null, durum: null });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  // /yenikart başarılı olduysa kişi id'si — tekrar denemede kart çoğaltılmasın.
  const [olusanKisiId, setOlusanKisiId] = useState(null);
  const [result, setResult] = useState(null); // { personId, assigned, kimlikDurum, ad, soyad, rows: [{ key, firma, durum, already, hata }] }
  const [kimlikAcik, setKimlikAcik] = useState(false);
  // Künye şeridi (#402): şeritten Kimlik Doğrula açılıp karar yazılınca / vesikalık yüklenince şerit yeni değeri gösterir.
  const [kimlikDurumYeni, setKimlikDurumYeni] = useState(null);
  const [fotoSurum, setFotoSurum] = useState(0);
  const [benzer, setBenzer] = useState(null); // { adaylar } — #288 uyarı penceresi

  // Bilinen kişinin firmaları (yalnızca SAKA; firma hesabı 403): { personId, data, hata }.
  const [firmalarYuk, setFirmalarYuk] = useState(null);
  const bilinenPersonId = bilinen?.personId && !firmaArayan ? bilinen.personId : null;
  const firmalarBekleniyor = bilinenKilitli && Boolean(bilinenPersonId) && firmalarYuk?.personId !== bilinenPersonId;
  const firmaVerisi = firmalarYuk?.personId === bilinenPersonId ? firmalarYuk?.data : null;
  const firmaKaydi = (id) => (firmaVerisi?.firmalar || []).find((f) => Number(f.firmaId) === Number(id)) ?? null;
  const fuardakiGorev = (id) => (firmaKaydi(id)?.gorevler || []).find((g) => Number(g.fuarId) === Number(fuarId)) ?? null;

  const satirFirma = (s) => kilitliFirma ?? s.firma;
  const satirFirmaId = (s) => {
    const f = satirFirma(s);
    return f?.firmaId ? Number(f.firmaId) : null;
  };
  // Boş bırakılan satırlar sessizce atlanır.
  const doluSatirlar = satirlar.filter((s) => satirFirmaId(s));
  const firmaIdleri = doluSatirlar.map(satirFirmaId);
  const tekrarEdenler = new Set(firmaIdleri.filter((id, i) => firmaIdleri.indexOf(id) !== i));
  const kilitliFirmaId = kilitliFirma?.firmaId ? Number(kilitliFirma.firmaId) : null;

  useEffect(() => {
    if (!fuarId) return undefined;
    let ignore = false;
    getMeslekList(fuarId)
      .then((list) => { if (!ignore) setMesleks(list || []); })
      .catch(() => { if (!ignore) setMesleks([]); });
    return () => { ignore = true; };
  }, [fuarId]);

  // Bilinen kişinin firmaları (#261). Ön dolum yalnızca listeden açılışta ve yalnızca dokunulmamış ilk satıra;
  // okunamazsa satırın kendi firması (`initialFirma`) yedek olur, "zaten bu fuarda" işareti de olmaz.
  useEffect(() => {
    if (!bilinenPersonId) return undefined;
    let ignore = false;
    getKisiFirmalari(bilinenPersonId)
      .then((data) => {
        if (ignore) return;
        setFirmalarYuk({ personId: bilinenPersonId, data, hata: null });
        if (bilinenKilitli) {
          const onDolum = onDolumFirmasi(data, fuarId);
          setSatirlar((p) => p.map((s, i) => (i === 0 && !s.firma ? { ...s, firma: onDolum } : s)));
        }
      })
      .catch((e) => {
        if (ignore) return;
        setFirmalarYuk({ personId: bilinenPersonId, data: null, hata: e.message });
        if (bilinenKilitli && initialFirma) {
          setSatirlar((p) => p.map((s, i) => (i === 0 && !s.firma ? { ...s, firma: initialFirma } : s)));
        }
      });
    return () => { ignore = true; };
    // Yalnızca kişi değişince; fuarId/initialFirma açılışta sabit.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bilinenPersonId]);

  const bagKeyleri = fuaraGorevlendir ? [...new Set(firmaIdleri)].map((id) => `${id}|${fuarId}|${bagToken}`) : [];
  const bagKeyleriStr = bagKeyleri.join(",");
  useEffect(() => {
    bagKeyleri.forEach((key) => {
      if (istenenBaglar.current.has(key)) return;
      istenenBaglar.current.add(key);
      const [id] = key.split("|");
      getFirmaFuarBaglari(Number(id), fuarId)
        .then((data) => setBaglar((p) => ({ ...p, [key]: { data, error: null } })))
        .catch((e) => setBaglar((p) => ({ ...p, [key]: { data: null, error: e.message } })));
    });
    // bagKeyleri bagKeyleriStr'den türetiliyor
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bagKeyleriStr]);
  const bagOf = (firmaId) => baglar[`${firmaId}|${fuarId}|${bagToken}`] ?? null;

  // ⚠️ Bu ön kontrol bugünkü sert kapıyı (#40) yansıtıyor. #80/#198 kapıyı kaldırır ya da yapılandırılabilir
  // yaparsa buradaki kontrol de aynı ayardan okunmalı — yoksa backend izin verirken ekranı kilitler.
  // Yalnızca kilitli firmada: firma arayan (portal) zaten tek, kendi firmasıyla çalışır.
  const vergiKey = firmaArayan && kilitliFirmaId ? String(kilitliFirmaId) : null;
  useEffect(() => {
    if (!vergiKey) return undefined;
    let ignore = false;
    // WAS (until #435): getTaxNumber(kilitliFirmaId)
    //   .then((no) => { if (!ignore) setVergi({ key: vergiKey, durum: no ? "var" : "yok" }); })
    // #435: bir Yabancı firma vergi numarası borçlu değildir (backend #434): "gerekmez" hiçbir şeyi engellemez, yalnızca "yok" engeller.
    getVergiNoDurumu(kilitliFirmaId)
      .then(({ taxNumber: no, gerekli }) => { if (!ignore) setVergi({ key: vergiKey, durum: !gerekli ? "gerekmez" : no ? "var" : "yok" }); })
      // Okunamazsa engelleme: kapıyı backend zaten uyguluyor, burası yalnızca yetim kartı önleyen ön kontrol.
      .catch(() => { if (!ignore) setVergi({ key: vergiKey, durum: "bilinmiyor" }); });
    return () => { ignore = true; };
    // kilitliFirmaId vergiKey'in içinde
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vergiKey]);
  const vergiEksik = vergiKey && vergi.key === vergiKey && vergi.durum === "yok";

  // #748 (backend #748): a new card needs a phone; only staff may leave it out, while Kayıt Ayarları' switch is on. A company login never asks.
  const [telefonsuzAcik, setTelefonsuzAcik] = useState(false);
  useEffect(() => {
    if (firmaArayan) return undefined;
    let ignore = false;
    getKisiTelefonsuzEklemeAcik().then((acik) => { if (!ignore) setTelefonsuzAcik(acik); });
    return () => { ignore = true; };
  }, [firmaArayan]);
  const telefonZorunlu = firmaArayan || !telefonsuzAcik;

  const yeniKayit = sorgu?.yapilabilecek === "YENI_KAYIT";
  const mevcutKisi = Boolean(sorgu?.personId);
  const devamEdilebilir = yeniKayit || (mevcutKisi && !sorgu?.yasakli);
  const firmaZorunlu = Boolean(kilitliFirma) || fuaraGorevlendir;
  const formKilitli = submitting;
  const kimlikUyari = yeniKayit ? kimlikUyarisi(sorgu.sorgulananKimlikNo || kimlikNo, form.nationalityId) : null;
  // Seçili mesleklerin istediği belgelerin birleşimi (#372: kişi o fuarda hepsinin belgesini üretmek zorunda).
  const belgelerOf = (meslekIds) => [...new Set(
    (meslekIds || []).flatMap((id) => mesleks.find((m) => Number(m.meslekId) === Number(id))?.belgeKurali?.belgeler || [])
      .map((b) => b.ad),
  )];

  const satirlarTamam = fuaraGorevlendir
    ? doluSatirlar.length > 0 && firmaIdleri.every((id) => Boolean(bagOf(id)?.data?.esli))
    : (firmaZorunlu ? doluSatirlar.length > 0 : (yeniKayit || doluSatirlar.length > 0));
  // Kişi bu fuarda o firmayla zaten varsa (bilinen kişi, SAKA) kayıt kapalı: aynı çağrı yalnızca mesleği güncellerdi,
  // reddedilmiş bir eşlemeyi de açmazdı. Firma listesi okunamadıysa kapı yok — bu yalnızca bir ön kontrol.
  const zatenFuardaIdleri = fuaraGorevlendir ? [...new Set(firmaIdleri)].filter((id) => fuardakiGorev(id)) : [];
  const kaydedilebilir = devamEdilebilir && !vergiEksik && tekrarEdenler.size === 0
    && zatenFuardaIdleri.length === 0 && satirlarTamam;

  function setField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  function satirGuncelle(key, patch) {
    setSatirlar((prev) => prev.map((s) => (s.key === key ? { ...s, ...patch } : s)));
  }
  // Yeni satır önceki satırın mesleğiyle başlar — çoğu zaman aynı kişi aynı işi yapıyor.
  function satirEkle() {
    setSatirlar((prev) => [...prev, yeniSatir(null, [...(prev[prev.length - 1]?.meslekIds ?? [])])]);
  }
  function satirSil(key) {
    setSatirlar((prev) => prev.filter((s) => s.key !== key));
  }

  function changeKimlik(value) {
    setKimlikNo(value);
    if (sorgu) setSorgu(null);
    setError(null);
  }

  async function handleSorgu(e) {
    e?.preventDefault?.();
    if (!kimlikNo.trim() || formKilitli) return null;
    setSorguLoading(true);
    setError(null);
    try {
      const out = await kimlikSorgu(kimlikNo.trim());
      setSorgu(out);
      // Uyruk yalnızca ön seçilir (11 haneli sayı → T.C.); kullanıcı değiştirebilir.
      if (out.yapilabilecek === "YENI_KAYIT") {
        setForm((prev) => ({ ...prev, nationalityId: varsayilanUyruk(out.sorgulananKimlikNo || kimlikNo) }));
      }
      return out;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setSorguLoading(false);
    }
  }

  function personFields() {
    return {
      idNumber: sorgu.sorgulananKimlikNo || kimlikNo.trim(),
      name: form.name.trim(),
      surname: form.surname.trim(),
      nationalityId: Number(form.nationalityId),
      phone: form.phone.trim(),
      email: form.email.trim() || undefined,
    };
  }

  /**
   * Kişi kartı (yeni kişiyse bir kez) → her firma satırı için sırayla liste ekleme + [fuar ataması].
   * Her firmanın sonucu ayrı tutulur; biri düşerse diğerleri etkilenmez ve sonuç ekranından yalnızca
   * düşenler yeniden denenir (kart ve başarılı satırlar tekrarlanmaz).
   */
  // `benzerOnay` yalnızca BENZER_KAYIT penceresindeki "Hayır, farklı kişi"den true gelir (onClick'ten olay değil).
  async function handleSubmit(benzerOnay = false) {
    // WAS (until #748): if (yeniKayit && !olusanKisiId && (!form.name.trim() || !form.surname.trim() || !form.phone.trim())) {
    //   setError(tx("personelEkle.adSoyadVeTelefonZorunlu"));
    if (yeniKayit && !olusanKisiId && (!form.name.trim() || !form.surname.trim() || (telefonZorunlu && !form.phone.trim()))) {
      setError(tx(telefonZorunlu ? "personelEkle.adSoyadVeTelefonZorunlu" : "personelEkle.adSoyadZorunlu"));
      return;
    }
    setSubmitting(true);
    setError(null);
    // Sonuç ekranının kimlik satırı için — yeni kart her zaman 0 (Doğrulanmadı) açılır.
    const kisi = yeniKayit
      ? { kimlikDurum: 0, ad: form.name.trim(), soyad: form.surname.trim() }
      : { kimlikDurum: Number(sorgu.kimlikDogrulamaDurum ?? 0), ad: sorgu.ad, soyad: sorgu.soyad };
    try {
      let personId = olusanKisiId;
      try {
        if (yeniKayit) {
          if (!personId) {
            personId = await createPersonAdmin({ ...personFields(), benzerKayitOnaylandi: benzerOnay === true });
            setOlusanKisiId(personId);
          }
        } else {
          personId = Number(sorgu.personId);
        }
      } catch (err) {
        // #288: kişi OLUŞTURULMADI; adaylar sorulur ("Evet, bu kişi" / "Hayır, farklı kişi").
        if (err.kod === "BENZER_KAYIT") {
          setBenzer({ adaylar: err.adaylar });
          return;
        }
        // Kart başka biri tarafından (ya da yarışta) az önce açılmışsa backend İngilizce 400 döner ve id vermez —
        // yeniden sorgulayıp kişiyi bulunmuş olarak gösteriyoruz.
        if (!personId && /already exists/i.test(err.message)) {
          await handleSorgu();
          setError(tx("personelEkle.buKimlikNumarasiZatenKayitli"));
        } else {
          setError(err.message);
        }
        return;
      }

      const sonuclar = { ...satirSonuc };
      for (const s of doluSatirlar) {
        const onceki = sonuclar[s.key];
        if (onceki?.durum === "ok") continue;
        const firmaId = satirFirmaId(s);
        let rosterTamam = Boolean(onceki?.rosterTamam);
        let already = Boolean(onceki?.already);
        try {
          if (!rosterTamam) {
            // WAS (until #357): already = (await addToRoster(firmaId, personId)).already;
            already = (await addToRoster(firmaId, personId, {
              calisanTipi: calisanTipiSecimi ? Number(calisanTipiSecimi) : undefined,
            })).already;
            rosterTamam = true;
          }
          if (fuaraGorevlendir) {
            await assignPersonToFirmaAdmin({ personId, firmaId, meslekIds: s.meslekIds }, fuarId);
          }
          sonuclar[s.key] = { durum: "ok", rosterTamam, already };
        } catch (err) {
          sonuclar[s.key] = { durum: "hata", rosterTamam, already, hata: err.message };
        }
      }
      setSatirSonuc(sonuclar);

      const rows = doluSatirlar.map((s) => ({ key: s.key, firma: satirFirma(s), ...sonuclar[s.key] }));
      const basarili = rows.filter((r) => r.durum === "ok");
      setResult({ ...kisi, personId, assigned: fuaraGorevlendir, rows });
      onDone?.({
        personId,
        assigned: fuaraGorevlendir && basarili.length > 0,
        already: basarili.length > 0 && basarili.every((r) => r.already),
      });
    } finally {
      setSubmitting(false);
    }
  }

  function reset() {
    setKimlikNo(""); setSorgu(null); setForm(EMPTY); setBilinen(null); setFirmalarYuk(null); setBenzer(null);
    setCalisanTipiSecimi("");
    setSatirlar([yeniSatir(initialFirma)]); setSatirSonuc({});
    setResult(null); setError(null); setKimlikAcik(false); setOlusanKisiId(null);
  }

  // #288 "Evet, bu kişi": yeni kart AÇILMAZ; adayla, var olan kişi gibi devam edilir (anahtar ve satırlar kullanıcıda kalır).
  function benzerKisiyiSec(aday) {
    const k = adaydanBilinenKisi(aday);
    setBenzer(null);
    setBilinen(k);
    setSorgu(bilinenSorgu(k));
    setError(null);
  }

  // "Başka kişi ara": #288'den bilinen kişiye düşülmüşse kimlik sorgusuna dön.
  function bilinenKaldir() {
    setBilinen(null);
    setSorgu(null);
    setFirmalarYuk(null);
    setError(null);
  }

  // ── Sonuç ──────────────────────────────────────────────────────────────────
  if (result) {
    const basarili = result.rows.filter((r) => r.durum === "ok");
    const basarisiz = result.rows.filter((r) => r.durum === "hata");
    const tek = result.rows.length === 1;
    const adi = (r) => r.firma?.firmaName || (firmaArayan ? tx("personelEkle.kendiFirmaniz") : `Firma #${r.firma?.firmaId}`);
    const baslik = result.rows.length === 0
      ? tx("personelEkle.kisiKaydedildi")
      : basarisiz.length > 0
        ? (tek ? tx("personelEkle.firmaKaydiTamamlanamadi") : tx("personelEkle.firmaTamamlandi", { length: basarili.length, length2: result.rows.length }))
        : tek
          ? (result.assigned ? tx("personelEkle.personelGorevlendirildi") : result.rows[0].already ? tx("personelEkle.kisiZatenListede") : tx("personelEkle.personelListeyeEklendi"))
          : (result.assigned
            ? tx("personelEkle.personelFirmayaGorevlendirildi", { length: result.rows.length })
            : tx("personelEkle.personelFirmaninListesineEklendi", { length: result.rows.length }));
    const detayFirmaId = basarili[0]?.firma?.firmaId;
    const detayYolu = firmaArayan
      ? `/Firma/Personel/${result.personId}`
      : `/Management/Firmalar/Personel/${detayFirmaId}/${result.personId}?fuarId=${fuarId}`;
    return (
      <>
        <Modal isOpen toggle={kimlikAcik ? undefined : onClose} centered>
          <ModalBody className="text-center py-4">
            {basarisiz.length > 0
              ? <AlertTriangle size={40} className="text-warning mb-2" />
              : <CheckCircle2 size={40} className="text-success mb-2" />}
            <h5 className="mb-1">{baslik}</h5>
            <div className="text-muted small">
              {[
                result.ad && `${result.ad} ${result.soyad || ""}`.trim(),
                tek && adi(result.rows[0]),
                result.assigned && basarili.length > 0 ? fuarEtiketi : null,
              ].filter(Boolean).join(" · ")}
            </div>
            {tek && result.assigned && result.rows[0].durum === "ok" && result.rows[0].already && (
              <div className="small mt-2">{tx("personelEkle.kisiZatenPersonelListenizdeydiFuara")}</div>
            )}
            {(!tek || basarisiz.length > 0) && result.rows.length > 0 && (
              <ul className="list-unstyled text-start small mt-3 mb-0">
                {result.rows.map((r) => (
                  <li key={r.key} className="d-flex align-items-start gap-2 py-1">
                    {r.durum === "ok"
                      ? <CheckCircle2 size={15} className="text-success flex-shrink-0 mt-1" />
                      : <XCircle size={15} className="text-danger flex-shrink-0 mt-1" />}
                    <span>
                      <span className="fw-medium">{adi(r)}</span>
                      {r.durum === "ok" && r.already && <span className="text-muted">{" "}{tx("personelEkle.zatenListede")}</span>}
                      {r.durum === "hata" && <span className="text-danger d-block">{r.hata}</span>}
                    </span>
                  </li>
                ))}
              </ul>
            )}
            {/* Kayıt tamam; kart için kimlik doğrulaması ayrıca gerekiyor (her fuarda). */}
            {/* Listeden "Fuara/Firmaya Eşle" ile açılan kilitli kişide bu uyarı çıkmaz (#402); "Kimliği Doğrula" düğmesi altta kalır. */}
            {!bilinenKilitli && <KimlikDogrulamaBilgisi durum={result.kimlikDurum} className="text-start mt-3" />}
          </ModalBody>
          <ModalFooter className="justify-content-center">
            <Button color="light" onClick={onClose}>{tx("common:kapat")}</Button>
            {basarisiz.length > 0 ? (
              <Button color="warning" onClick={() => handleSubmit()} disabled={submitting}>
                {submitting ? <Spinner size="sm" /> : tx("personelEkle.basarisizlariTekrarDene")}
              </Button>
            ) : !bilinenKilitli && (
              <Button color="light" onClick={reset}>{tx("personelEkle.birKisiDaha")}</Button>
            )}
            {!firmaArayan && result.kimlikDurum !== 1 && (
              <Button color="primary" outline onClick={() => setKimlikAcik(true)}>
                <ShieldCheck size={14} className="me-1" />{tx("personelEkle.kimligiDogrula")}
              </Button>
            )}
            {result.assigned && detayFirmaId && (
              <Link to={detayYolu} className="btn btn-primary" onClick={onClose}>{tx("personelEkle.detayiAc")}</Link>
            )}
          </ModalFooter>
        </Modal>

        {/* Mevcut staff eylemi (Kişi Listesi satırındakiyle aynı modal). Kimlik sorgusu belge
            listesi döndürmediği için dayanak seçeneği yalnızca "dosya yok" olur; belgeli doğrulama
            için kişi detayındaki Kimlik Doğrulama bölümü kullanılır. */}
        {kimlikAcik && (
          <KimlikDogrulamaModal
            person={{ personId: result.personId, name: result.ad, surname: result.soyad }}
            onClose={() => setKimlikAcik(false)}
            onSaved={(_, res) => {
              setKimlikAcik(false);
              setResult((r) => ({ ...r, kimlikDurum: res?.durum != null ? Number(res.durum) : r.kimlikDurum }));
              onDone?.({
                personId: result.personId,
                assigned: result.assigned && basarili.length > 0,
                already: basarili.length > 0 && basarili.every((r) => r.already),
              });
            }}
          />
        )}
      </>
    );
  }

  // ── Form ───────────────────────────────────────────────────────────────────
  // Künye şeridinin bildiği kişi (KisiKunyeSeridi'nin `person` şekli) — yalnızca kilitli bilinen kişide kullanılır.
  const kunyeKisi = bilinen
    ? {
      personId: bilinen.personId, name: bilinen.ad, surname: bilinen.soyad, tcNo: bilinen.kimlikNo, phone: bilinen.telefon,
      fotografVar: bilinen.fotografVar,
    }
    : null;
  const altPopupAcik = firmaOlusturSatir != null || Boolean(esleHedef) || Boolean(benzer) || (kimlikAcik && bilinenKilitli);
  const silinebilir = !kilitliFirma && satirlar.length > 1;
  const firmaSayisi = doluSatirlar.length;
  const sayiEki = firmaSayisi > 1 ? ` (${firmaSayisi} firma)` : "";

  return (
    <>
      <Modal isOpen toggle={altPopupAcik ? undefined : onClose} centered size="lg">
        <ModalHeader toggle={onClose}>{bilinenKilitli ? eslemeAdi : tx("personelEkle.personelEkle")}</ModalHeader>
        {/* data-tour-baglam: kullanım turu (services/egitimTuru.js) açık pencereyi bununla tanır */}
        <ModalBody data-tour-baglam={BAGLAM.PERSONEL_EKLE}>
          {error && <Alert fade={false} color="danger" className="py-2 small">{error}</Alert>}

          {/* Kart Yazdır / Kimlik Doğrula ile ortak künye şeridi (#402). Firma satırı yok: firma aşağıda seçilir. */}
          {bilinenKilitli && bilinen && (
            <KisiKunyeSeridi
              person={kunyeKisi}
              kimlikDurum={kimlikDurumYeni ?? bilinen.kimlikDurum ?? 0}
              fotografVar={Boolean(bilinen.fotografVar) || fotoSurum > 0}
              fotoSurum={fotoSurum}
              fuarAdi={fuarEtiketi}
              fuarLogoUrl={fuarLogoUrl}
              onKimlik={firmaArayan ? undefined : () => setKimlikAcik(true)}
            />
          )}

          {/* #477: kişinin firmaları ve üst çubuk fuarındaki durumları; aynı işlem ikinci kez yapılmasın. Yalnızca SAKA (firma hesabı 403). */}
          {bilinenKilitli && fuarId && firmaVerisi && (
            <KisiFirmalariOzeti firmalar={firmaVerisi.firmalar} fuarId={fuarId} />
          )}

          {!bilinen && (
            <form onSubmit={handleSorgu} data-tour="personel-ekle-sorgu">
              {/* #591: Yabancı seçilince alan yalnızca pasaport numarasıdır (WAS: hep "T.C. / Pasaport No").
                  #702: T.C. seçilince de yalnızca "T.C. Kimlik No" (WAS: o zaman da "T.C. / Pasaport No"). */}
              <Label className="small mb-1">{tx(yeniKayit && form.nationalityId === "2" ? "personelEkle.pasaportNo" : yeniKayit && form.nationalityId === "1" ? "personelEkle.tcKimlikNo" : "personelEkle.tCPasaportNo")}</Label>
              <InputGroup>
                <Input
                  autoFocus value={kimlikNo} placeholder={tx("personelEkle.n11HaneliTCVeya")} disabled={formKilitli}
                  onChange={(e) => changeKimlik(e.target.value)}
                />
                <Button color="primary" type="submit" disabled={sorguLoading || formKilitli || !kimlikNo.trim()}>
                  {sorguLoading ? <Spinner size="sm" /> : <><Search size={14} className="me-1" />{tx("personelEkle.sorgula")}</>}
                </Button>
              </InputGroup>
            </form>
          )}

          {sorgu && (
            <div className={bilinen ? "" : "mt-3"}>
              {yeniKayit ? (
                <Row className="g-2">
                  <Col md={6}>
                    <Label className="small mb-1">{tx("personelEkle.ad")}</Label>
                    <Input value={form.name} disabled={formKilitli} onChange={(e) => setField("name", e.target.value)} />
                  </Col>
                  <Col md={6}>
                    <Label className="small mb-1">{tx("personelEkle.soyad")}</Label>
                    <Input value={form.surname} disabled={formKilitli} onChange={(e) => setField("surname", e.target.value)} />
                  </Col>
                  <Col md={4}>
                    <Label className="small mb-1">{tx("personelEkle.uyruk")}</Label>
                    <Input
                      type="select" value={form.nationalityId} disabled={formKilitli}
                      onChange={(e) => setField("nationalityId", e.target.value)}
                    >
                      <option value="1">T.C.</option>
                      <option value="2">{tx("personelEkle.yabanci")}</option>
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Label className="small mb-1">{tx(telefonZorunlu ? "personelEkle.telefon" : "personelEkle.telefonIstegeBagli")}</Label>
                    {/* WAS (until #746): <Input type="tel" value={form.phone} placeholder="05xxxxxxxxx" disabled={formKilitli} onChange={(e) => setField("phone", e.target.value)} /> */}
                    <TelefonGirdisi id="pe-telefon" value={form.phone} disabled={formKilitli} onChange={(v) => setField("phone", v)} />
                  </Col>
                  <Col md={4}>
                    <Label className="small mb-1">{tx("personelEkle.ePosta")}</Label>
                    <Input type="email" value={form.email} disabled={formKilitli} onChange={(e) => setField("email", e.target.value)} />
                  </Col>
                  {kimlikUyari && (
                    <Col xs={12}>
                      <Alert fade={false} color="warning" className="py-2 px-2 mb-0 small d-flex align-items-start gap-2">
                        <AlertTriangle size={14} className="flex-shrink-0 mt-1" />
                        <span>{kimlikUyari}</span>
                      </Alert>
                    </Col>
                  )}
                  <Col xs={12}>
                    <KimlikDogrulamaBilgisi yeniKayit className="mt-1" />
                  </Col>
                </Row>
              ) : bilinenKilitli ? (
                // Kişi bilgisi yukarıdaki şeritte; yasaklıysa devam edilemez, nedeni burada söylenir.
                sorgu.yasakli && <Badge color="danger" className="fw-normal">{tx("personelEkle.girisiYasakli")}</Badge>
              ) : (
                <div className="p-3 rounded border d-flex justify-content-between align-items-start gap-3">
                  <div className="small">
                    {mevcutKisi ? (
                      <>
                        <div className="fw-semibold fs-6">{sorgu.ad} {sorgu.soyad}</div>
                        {bilinen?.kimlikNo && <div className="text-muted">{bilinen.kimlikNo}</div>}
                        {sorgu.telefon && <div className="text-muted">{sorgu.telefon}</div>}
                        {sorgu.gecmisGorevler?.[0] && (
                          <div className="text-muted">
                            {tx("personelEkle.sonGorev2", { fuar_adi: sorgu.gecmisGorevler[0].fuar_adi, firma_name: sorgu.gecmisGorevler[0].firma_name })}
                          </div>
                        )}
                        {sorgu.dahaOnceCalisti && (
                          <div className="text-success mt-1">
                            <CheckCircle2 size={13} className="me-1" />{tx("personelEkle.buKisiDahaOnceFirmanizda")}
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-muted">{sorgu.sonuc?.aciklama ?? tx("personelEkle.kayitBulunamadi")}</div>
                    )}
                  </div>
                  <Badge color={sorgu.yasakli ? "danger" : (sorgu.sonuc?.color ?? "secondary")} className="fw-normal flex-shrink-0">
                    {sorgu.yasakli ? tx("personelEkle.girisiYasakli") : (sorgu.sonuc?.label ?? sorgu.yapilabilecek)}
                  </Badge>
                </div>
              )}
              {bilinen && !bilinenKilitli && (
                <Button color="link" size="sm" className="p-0 mt-1" onClick={bilinenKaldir} disabled={formKilitli}>
                  {tx("personelEkle.baskaKisiAra")}
                </Button>
              )}
              {/* Mükerrer TCKN — bu uyarıyı yalnızca SAKA görür (35 mükerrer grup var). */}
              {sorgu.uyari && (
                <Alert fade={false} color="warning" className="small d-flex gap-2 mt-2 mb-0">
                  <AlertTriangle size={16} className="flex-shrink-0 mt-1" />
                  <span>{sorgu.uyari}</span>
                </Alert>
              )}
              {/* Kart kapısı olduğu için rozet + not. Kilitli bilinen kişide yok: durum künye şeridinde (#402). */}
              {mevcutKisi && !bilinenKilitli && (
                <KimlikDogrulamaBilgisi
                  durum={sorgu.kimlikDogrulamaDurum} durumAdi={sorgu.kimlikDogrulamaDurumAdi} className="mt-2"
                />
              )}

              {devamEdilebilir && (
                <>
                  {fuarId && bilinenKilitli && (
                    <div className="small mt-3 mb-2">
                      <span className="text-muted">{tx("personelEkle.fuar2")}{" "}</span><span className="fw-medium">{fuarEtiketi}</span>
                    </div>
                  )}
                  {fuarId && !bilinenKilitli && (
                    <FormGroup switch className="mt-3 mb-2">
                      <Input
                        type="switch" id="personelEkleFuaraGorevlendir" checked={fuaraGorevlendir}
                        onChange={(e) => setFuaraGorevlendir(e.target.checked)}
                      />
                      <Label check for="personelEkleFuaraGorevlendir">
                        {tx("personelEkle.kisiyiFuaraGorevlendir")}{" "}<span className="text-muted">— {fuarEtiketi}</span>
                      </Label>
                    </FormGroup>
                  )}

                  {firmalarBekleniyor && (
                    <div className="small text-muted mt-2"><Spinner size="sm" className="me-1" />{tx("personelEkle.kisininFirmalariOkunuyor")}</div>
                  )}

                  {!firmalarBekleniyor && satirlar.map((s, i) => {
                    const sFirma = satirFirma(s);
                    const sId = satirFirmaId(s);
                    const belgeler = belgelerOf(s.meslekIds);
                    return (
                      <Row key={s.key} className="g-2 mt-0 align-items-start">
                        <Col md={(fuaraGorevlendir ? 7 : 12) - (silinebilir ? 1 : 0)}>
                          {kilitliFirma ? (
                            <div className="small">
                              <span className="text-muted">{tx("personelEkle.firma")}{" "}</span>
                              <span className="fw-medium">
                                {sFirma.firmaName || (firmaArayan ? tx("personelEkle.kendiFirmaniz") : `#${sFirma.firmaId}`)}
                              </span>
                              {!fuaraGorevlendir && <span className="text-muted">{" "}{tx("personelEkle.kisiBuFirmaninPersonelListesine")}</span>}
                            </div>
                          ) : (
                            <FirmaSearchSelect
                              label={i === 0 ? (fuaraGorevlendir ? tx("personelEkle.firma2") : tx("personelEkle.firmaIstegeBagli")) : tx("personelEkle.firma3", { v: i + 1 })}
                              value={s.firma} forceLive onChange={(f) => satirGuncelle(s.key, { firma: f })}
                              // Arama kutusuna yazılan, eşleşmeyen firma adı yeni firmanın adına taşınır (#281).
                              onCreateNew={firmaArayan ? null : (aranan) => { setFirmaOlusturAd(aranan || ""); setFirmaOlusturSatir(s.key); }}
                            />
                          )}
                          {sId && tekrarEdenler.has(sId) && (
                            <div className="small text-danger mt-1">{tx("personelEkle.buFirmaListedeBirdenFazla")}</div>
                          )}
                          {fuaraGorevlendir && sId && (
                            <FirmaIliskiNotu kayit={firmaKaydi(sId)} gorev={fuardakiGorev(sId)} />
                          )}
                          {fuaraGorevlendir && sId && (
                            <BagDurumu
                              bag={bagOf(sId)} firmaArayan={firmaArayan}
                              onEsle={() => setEsleHedef({ firma: sFirma, yeniFirma: yeniFirmaIdleri.includes(sId) })}
                            />
                          )}
                        </Col>
                        {fuaraGorevlendir && (
                          <Col md={silinebilir ? 4 : 5}>
                            <Label className="small mb-1">{tx("personelEkle.meslek")}</Label>
                            <MeslekSecici
                              secili={s.meslekIds} katalog={mesleks}
                              onChange={(ids) => satirGuncelle(s.key, { meslekIds: ids })}
                            />
                            {belgeler.length > 0 && (
                              <div className="form-text small">{tx("personelEkle.istenecekKvkk")}{" "}{belgeler.join(", ")}</div>
                            )}
                          </Col>
                        )}
                        {silinebilir && (
                          <Col md={1} className="d-flex align-items-end" style={{ minHeight: 58 }}>
                            <Button
                              color="link" size="sm" className="p-0 text-danger" title={tx("personelEkle.satiriKaldir")}
                              onClick={() => satirSil(s.key)}
                            >
                              <X size={18} />
                            </Button>
                          </Col>
                        )}
                      </Row>
                    );
                  })}

                  {!kilitliFirma && !firmalarBekleniyor && satirlar.length < MAKS_FIRMA && (
                    <Button color="link" size="sm" className="p-0 mt-2" onClick={satirEkle}>
                      <Plus size={14} className="me-1" />{tx("personelEkle.firmaEkle")}
                    </Button>
                  )}

                  {!calisanTipiGizli && (
                    <div className="mt-3">
                      <Label className="small mb-1" for="personelEkleCalisanTipi">{tx("personelSekmeler.tipEtiketi")}</Label>
                      <Input
                        type="select" bsSize="sm" id="personelEkleCalisanTipi" style={{ maxWidth: 220 }}
                        value={calisanTipiSecimi} onChange={(e) => setCalisanTipiSecimi(e.target.value)}
                      >
                        <option value="">{tx("personelSekmeler.tipBelirsiz")}</option>
                        <option value="1">{tx("personelSekmeler.tipDaimi")}</option>
                        <option value="2">{tx("personelSekmeler.tipGecici")}</option>
                      </Input>
                      <div className="form-text small">{tx("personelSekmeler.tipSonradan")}</div>
                    </div>
                  )}

                  {vergiEksik && (
                    <Alert fade={false} color="danger" className="py-2 small mt-3 mb-0">
                      {tx("personelEkle.firmanizinVergiNumarasiGirilmemisVergi")}
                    </Alert>
                  )}
                </>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={onClose} disabled={submitting}>{tx("common:iptal")}</Button>
          <Button color="success" onClick={() => handleSubmit()} disabled={!kaydedilebilir || submitting} data-tour="personel-ekle-kaydet">
            {submitting
              ? <Spinner size="sm" />
              : !sorgu
                ? tx("common:ekle")
                : fuaraGorevlendir
                  ? `${yeniKayit ? tx("personelEkle.olusturVeGorevlendir") : bilinenKilitli ? eslemeAdi : tx("personelEkle.ekleVeGorevlendir")}${sayiEki}`
                  : firmaSayisi > 0
                    ? `${yeniKayit ? tx("personelEkle.olusturVeListeyeEkle") : tx("personelEkle.listeyeEkle")}${sayiEki}`
                    : tx("personelEkle.kisiyiOlustur")}
          </Button>
        </ModalFooter>
      </Modal>

      {firmaOlusturSatir != null && (
        <CreateFirmaModal
          isOpen
          forceLive
          showEsle={false}
          fuarId={fuarId}
          defaultName={firmaOlusturAd}
          onClose={() => setFirmaOlusturSatir(null)}
          onCreated={(yeni) => {
            satirGuncelle(firmaOlusturSatir, { firma: yeni });
            setYeniFirmaIdleri((p) => [...p, Number(yeni.firmaId)]);
            setFirmaOlusturSatir(null);
            if (fuaraGorevlendir) setEsleHedef({ firma: yeni, yeniFirma: true });
          }}
        />
      )}

      {benzer && (
        <BenzerKisiModal
          benzer={benzer}
          kimlikNo={sorgu?.sorgulananKimlikNo || kimlikNo.trim()}
          busy={submitting}
          onEvet={benzerKisiyiSec}
          onHayir={() => { setBenzer(null); handleSubmit(true); }}
          onVazgec={() => setBenzer(null)}
        />
      )}

      {/* Künye şeridindeki "Kimlik Doğrula / Foto Ekle" (#402): Kart Yazdır'daki gibi bu pencerenin ÜSTÜNE yığılır. */}
      {kimlikAcik && bilinenKilitli && bilinen && (
        <KimlikDogrulamaModal
          person={{
            ...kunyeKisi,
            fotografVar: Boolean(bilinen.fotografVar) || fotoSurum > 0,
            kimlikDogrulama: { durum: kimlikDurumYeni ?? bilinen.kimlikDurum ?? 0 },
          }}
          fuarAdi={fuarEtiketi}
          fuarLogoUrl={fuarLogoUrl}
          onClose={() => setKimlikAcik(false)}
          onSaved={(_, res) => {
            setKimlikAcik(false);
            if (res?.durum != null) setKimlikDurumYeni(Number(res.durum));
            onDone?.({ personId: bilinen.personId, assigned: false, already: false });
          }}
          onFotoDegisti={() => { setFotoSurum((n) => n + 1); onDone?.({ personId: bilinen.personId, assigned: false, already: false }); }}
        />
      )}

      {esleHedef && (
        <FirmaFuarEsleModal
          firma={esleHedef.firma}
          yeniFirma={esleHedef.yeniFirma}
          fuarId={fuarId}
          fuarLabel={fuarEtiketi}
          onClose={() => setEsleHedef(null)}
          onDone={() => { setEsleHedef(null); setBagToken((t) => t + 1); }}
        />
      )}
    </>
  );
}
